import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    question: '¿Qué voy a recibir exactamente?',
    answer: 'Vas a recibir acceso inmediato al recetario digital con +500 recetas, más los bonos incluidos en esta oferta especial.'
  }, {
    question: '¿Cómo accedo al material?',
    answer: 'Una vez realizada la compra, recibís acceso digital para verlo y descargarlo desde tu celular, tablet o computadora.'
  }, {
    question: '¿Necesito saber cocinar?',
    answer: 'No. Las recetas están pensadas para que cualquier persona pueda seguirlas de manera simple y práctica.'
  }, {
    question: '¿Es solo para personas con dieta estricta?',
    answer: 'No. También es ideal para quienes simplemente quieren comer mejor, reducir azúcar, tener más opciones y disfrutar recetas más livianas.'
  }, {
    question: '¿Tiene garantía?',
    answer: 'Sí. Tenés 7 días para probar el material. Si sentís que no era lo que esperabas, podés solicitar tu reembolso.'
  }];
  const fadeInUp = {
    initial: {
      opacity: 0,
      y: 20
    },
    whileInView: {
      opacity: 1,
      y: 0
    },
    viewport: {
      once: true
    },
    transition: {
      duration: 0.5
    }
  };
  return <section className="py-16 px-4 bg-cream" data-id="element-50">
      <div className="max-w-3xl mx-auto" data-id="element-51">
        <motion.h2 {...fadeInUp} className="font-playfair text-3xl md:text-5xl font-bold text-center text-dark mb-12" data-id="element-52">
          Preguntas frecuentes
        </motion.h2>

        <div className="space-y-4" data-id="element-53">
          {faqs.map((faq, index) => <motion.div key={index} {...fadeInUp} transition={{
          delay: index * 0.05
        }} className="bg-white rounded-xl shadow-md overflow-hidden" data-id="element-54">
              <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full flex items-center justify-between p-6 text-left hover:bg-primary/5 transition-colors" data-id="element-55">
                <span className="font-semibold text-lg text-dark pr-4" data-id="element-56">
                  {faq.question}
                </span>
                <ChevronDown className={`w-6 h-6 text-primary flex-shrink-0 transition-transform ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-57" />
              </button>

              <AnimatePresence data-id="element-58">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-59">
                    <div className="px-6 pb-6 text-dark/80 leading-relaxed" data-id="element-60">
                      {faq.answer}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}